import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=e9e20fd8&"
import script from "./Phone.vue?vue&type=script&lang=js&"
export * from "./Phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports